<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="8"
        >
          <h3 class="mb-1">
            قائمة أوامر الرفع المساحي
          </h3>
          <b-card-text class="mb-0">
            عرض أوامر الرفع المساحي من السيرفر.
          </b-card-text>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="d-flex justify-content-end align-items-center"
        >
          <b-button
            :disabled="loading"
            variant="primary"
            @click="fetchOrders"
          >
            <b-spinner
              v-if="loading"
              small
              class="mr-50"
            />
            تحديث
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="mt-2">
      <b-table
        :items="items"
        :fields="fields"
        responsive
        striped
        hover
        small
      >
        <template #cell(id)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
      </b-table>
      <div
        v-if="!loading && items.length === 0"
        class="text-muted"
      >
        لا توجد بيانات للعرض.
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BButton,
  BTable,
  BBadge,
  BSpinner,
} from 'bootstrap-vue'
import landsurveyOrdersAPI from '@/api/landsurvey-orders/landsurveyOrders'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'LandSurveyOrdersList',
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BSpinner,
  },
  data() {
    return {
      loading: false,
      items: [],
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'code', label: 'الكود', sortable: true },
        { key: 'customer_name', label: 'العميل', sortable: true },
        { key: 'phone', label: 'التليفون', sortable: false },
        { key: 'created_at', label: 'تاريخ الإنشاء', sortable: true },
      ],
    }
  },
  mounted() {
    this.fetchOrders()
  },
  methods: {
    normalizeItems(payload) {
      // supports: {data: {data: []}}, {data: []}, or [] directly
      if (Array.isArray(payload)) return payload
      if (payload && Array.isArray(payload.data)) return payload.data
      if (payload && payload.data && Array.isArray(payload.data.data)) return payload.data.data
      return []
    },
    async fetchOrders() {
      this.loading = true
      try {
        const res = await landsurveyOrdersAPI.list()
        const data = res.data || res
        this.items = this.normalizeItems(data)
      } catch (e) {
        this.items = []
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'خطأ',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: e.response?.data?.message || e.message || 'تعذر تحميل القائمة',
          },
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
